// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedRecord: null
}

const record = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA_DASHBOARD_WIDGETS':
      return { ...state, allData: action.data }
    case 'GET_DATA_DASHBOARD_WIDGETS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_DASHBOARD_RECORD':
      return { ...state, selectedRecord: action.selectedRecord }
   
      return { ...state }
    default:
      return { ...state }
  }
}
export default record
